// frontend/src/components/p2p/CancelOrderButton.tsx
import { Loader2, X } from 'lucide-react';

interface Props {
  orderId: string;
  onCancel: (orderId: string) => void;
  pending: boolean;
}

export function CancelOrderButton({ orderId, onCancel, pending }: Props) {
  return (
    <button
      type="button"
      onClick={() => onCancel(orderId)}
      disabled={pending}
      className="p-1.5 rounded bg-red-500/15 border border-red-500/20 text-red-400 hover:bg-red-500/25 transition-all disabled:opacity-50"
      title="Cancelar orden"
    >
      {pending ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <X className="w-3.5 h-3.5" />}
    </button>
  );
}
